/*
 * Copyright (c) 2022-2026 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */
import { z } from 'zod'

export const OrganizationPriority = z.object({
  gameTitles: z.array(z.string()),
  segmentation: z.string(),
  support: z.string(),
  supportTier: z.string()
})

export interface OrganizationPriority extends z.TypeOf<typeof OrganizationPriority> {}
